//-------------------------
// calc maximum skill ticks
//--------------------------
export default function calcMaxTicks(parm) {
  
  const base = Number(parm.base) || 0
  const training = Number(parm.training) || 0
  const max_skill = Number(parm.max_skill)

  // rule: max ticks cannot exceed base + training
  const capByTraining = base + training

  // if max_skill not provided
  if (!Number.isFinite(max_skill)) {
    return Math.max(0, Math.floor(capByTraining))
  }

  // otherwise compute cap implied by max_skill and take the tighter constraint
  const capByMaxSkill = max_skill - (base + training) // may be negative
  const ticks_max = Math.max(0, Math.floor(Math.min(capByTraining, capByMaxSkill)))

  return ticks_max
}
